import { createFileRoute, Navigate } from "@tanstack/react-router"
import { Configuration } from "modules/campaigns/components/Detail/Configuration"
import { useCampaignQuery } from "modules/campaigns/hooks/useCampaignQuery"
import { CampaignStatusEnum } from "schema"
import { z } from "zod"

const SearchSchema = z.object({
  section: z.string().optional(),
  focus: z.string().optional(),
  templatePicker: z.string().optional(),
})

export const Route = createFileRoute("/_base/_auth/campaigns/$id/configuration")({
  validateSearch: SearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { section } = Route.useSearch()
  const { data: campaign } = useCampaignQuery(id)
  if (campaign?.isLogistics) {
    return <Navigate to="/campaigns/$id/insights" params={{ id }} replace />
  }

  const isEditable =
    (campaign?.status === CampaignStatusEnum.Draft ||
      campaign?.status === CampaignStatusEnum.Paused) &&
    !campaign?.isLogistics

  return <Configuration campaignId={id} isEditable={isEditable ?? false} section={section} />
}
